"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenuItem = void 0;
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var DropdownMenuTrigger_1 = __importDefault(require("./DropdownMenuTrigger"));
var classnames_1 = __importDefault(require("classnames"));
var defaultProps = {
    closeOnClick: true,
    align: 'right',
};
var useStyles = (0, react_jss_1.createUseStyles)(function (_a) {
    var colors = _a.colors, borderRadius = _a.borderRadius;
    return ({
        dropdownMenu: function (styles) { return (__assign({ position: 'relative', width: 32, height: 32, zIndex: 101 }, styles)); },
        open: {},
        menu: {
            position: 'absolute',
            top: '100%',
            right: 0,
            padding: '6px 0',
            backgroundColor: colors.Grey[0],
            color: colors.Grey[1000],
            borderRadius: borderRadius.sm,
            boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)",
            pointerEvents: 'none',
            opacity: 0,
            transition: 'all ease-in .1s, opacity ease .2s',
            transform: 'translateY(-5px)',
            '$open &': {
                pointerEvents: 'all',
                opacity: 1,
                transform: 'translateY(0)',
            },
        },
        alignLeft: {
            right: 'auto',
            left: 0,
        },
        overlay: {
            position: 'fixed',
            zIndex: 100,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
        },
        alignBottom: {
            top: 'auto',
            bottom: '100%',
        },
    });
});
var DropdownMenu = function (_a) {
    var _b, _c;
    var style = _a.style, children = _a.children, align = _a.align, closeOnClick = _a.closeOnClick, verticalAlign = _a.verticalAlign, triggerComponent = _a.triggerComponent;
    var _d = (0, react_1.useState)(false), open = _d[0], setOpen = _d[1];
    var styles = useStyles(style);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        open && (react_1.default.createElement("div", { onClick: function () { return setOpen(false); }, className: styles.overlay })),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.dropdownMenu, (_b = {}, _b[styles.open] = open, _b)) },
            react_1.default.createElement(DropdownMenuTrigger_1.default, { onClick: function () { return setOpen(!open); }, open: open, component: triggerComponent }),
            react_1.default.createElement("div", { onClick: function () { return closeOnClick && setOpen(false); }, className: (0, classnames_1.default)(styles.menu, (_c = {},
                    _c[styles.alignLeft] = align === 'left',
                    _c[styles.alignBottom] = verticalAlign === 'bottom',
                    _c)) }, children))));
};
DropdownMenu.defaultProps = defaultProps;
exports.default = DropdownMenu;
var DropdownMenuItem_1 = require("./DropdownMenuItem");
Object.defineProperty(exports, "DropdownMenuItem", { enumerable: true, get: function () { return __importDefault(DropdownMenuItem_1).default; } });
//# sourceMappingURL=index.js.map